import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { EABatchDetailVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const retrieveEducationalAdvisorBatch = createAsyncThunk<EABatchDetailVM, string, { extra: Partial<Dependencies> }>(
  "educationalAdvisor/retrieveBatch",
  async (id: string, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.batchDetail(id);
  },
);

export const resetRetrieveEducationalAdvisorBatch = createAction("educationalAdvisor/resetRetrieveBatch");
